import React from 'react';
import TrouveEcole from '../../RechercheEcole/TrouveEcole';

const ChoixEcole = ({ setEcole_selection, code_dept, cheminpush, info_ }) => {
  return (
    <div>
      <TrouveEcole
        setEcole_selection={setEcole_selection}
        code_dept={code_dept}
        cheminpush={cheminpush}
        info_={info_}
        eni='eni'
      />
    </div>
  );
};

export default ChoixEcole;
